import React from 'react';

import Form from '../../../../gd-form/form/form-modal/form-modal.jsx';
import FormManager from '../../../../gd-form/common/form-manager';
import ButtonSubmitDeprecated from 'core/gd-form/common/btn-submit/btn-submit';

import SettingsFormProto from '../../settings-form-proto';

class StringSettingsForm extends SettingsFormProto {

    constructor(props) {
        super(props);
        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {

        result.type = gd.const.customFields.type.STRING;

        const field = this.props.field;
        field.label = result.name.trim();
        field.description = result.description;
        field.isRequired = result.isRequired;

        this.props.onSubmit(field);
    }

    render() {
        return (
            <div className="form-container">
                {this.renderForm()}
                <div className="modal-submit">
                    <ButtonSubmitDeprecated form={this.form} className="submit" label="Submit" />
                </div>
            </div>
        );
    }

    renderForm() {

        return (
            <Form form={this.form} className="create-new-custom-field-form main" submitButton={false}>

                {this.renderType()}
                {this.renderName()}
                {this.renderDescription()}
                {this.renderIsRequired()}


                <div className="row cf preview-row">
                    <div className="label">Preview</div>
                    <div className="element">

                        <div className="gd-field-string preview">
                            <div className="value">Lorem ipsum</div>
                        </div>

                    </div>
                    <div className="cf" />
                </div>

            </Form>
        );
    }
}



export default function renderStringFormFieldFormElement(field, props) {
    return <StringSettingsForm field={field} {...props} />;
}
